import React, {useEffect} from "react";
import { Segmented } from "antd";
import classNames from "classnames";

const CustomTabs = ({
    tabs = [],
    activeTab,
    onChange,
    className = "",
    height = "h-12",
    ...rest
}) => {
    const options = tabs.map((tab) => ({
        label: (
            <div className="flex items-center justify-center gap-1.5">
                {tab.icon &&
                    React.cloneElement(tab.icon, { className: "w-4 h-4" })}
                <span >{tab.label}</span>
            </div>
        ),
        value: tab.value,
    }));

    const handleTabChange = (key) => {
        const currentURLWithoutFragment = window.location.href.split('#')[0] + '#' + key;
        window.history.replaceState({}, document.title, currentURLWithoutFragment);
        onChange(key);
    }

    useEffect(() => {
        const tabKey = window.location.hash;
        if (tabKey && tabKey.length > 1) {
            onChange(tabKey.substring(1));
        }
    }, []);


    return (
        <Segmented
            {...rest}
            block
            options={options}
            value={activeTab}
            onChange={handleTabChange}
            className={classNames(
                "bg-gray-100 dark:bg-white/20 dark:text-white/30 font-medium text-slate-900 rounded-2xl",
                height,
                className,
                "custom-segmented"
            )}
        />
    );
};

export default CustomTabs;
